import Header from "../components/Header";
import Footer from "../components/Footer";
import { CiLink } from "react-icons/ci";

export default function Education() {

    return (
        <div className="flex flex-col flex-grow w-screen min-h-screen items-center">
            <Header />
            <main className="bg-topography w-screen h-screen flex flex-col items-center justify-center">
                <div className="w-screen h-12" />
                <div className="w-full h-fit flex flex-col items-center justify-around gap-2">
                    <div className="animate-slide-in-left w-full h-fit flex items-center justify-center">
                        <div className="isolate aspect-video w-96 rounded-xl bg-background border-[#FFD700] border-2 shadow-lg ring-1 ring-black/5 px-6 py-2 flex flex-col items-start justify-center">
                            <h1 className="w-fit h-fit text-xl text-semibold text-text">
                                Doctor of Philosophy (PhD)
                            </h1>
                            <h3 className="text-text font-bold text-lg">
                                Queensland University of Technology
                            </h3>
                            <p className="text-text font-semibold text-base mb-2">
                                2022-2025
                            </p>
                            <a href="https://eprints.qut.edu.au/257552/" target="_blank" rel="noopener noreferrer" className="cursor-pointer font-light text-text flex items-center justify-start gap-2 hover:brightness-110 hover:text-primary"><CiLink className="text-text w-8 h-8"/>Optimal Partitioning Strategies for Statistical Regionalisation</a>
                        </div>

                    </div>
                    <div className="animate-slide-in-right w-full h-fit flex items-center justify-center">
                        <div className="isolate aspect-video w-96 rounded-xl bg-background border-[#C0C0C0] border-2 shadow-lg ring-1 ring-black/5 px-6 py-2 flex flex-col items-start justify-center">
                            <h1 className="w-fit h-fit text-xl text-semibold text-text">
                                Bachelor of Statistics
                            </h1>
                            <h3 className="text-text font-bold text-lg">
                                Queensland University of Technology
                            </h3>
                            <p className="text-text font-semibold text-base">
                                2018-2021
                            </p>
                        </div>
                    </div>
                    <div className="animate-slide-in-left w-full h-fit flex items-center justify-center">
                        <div className="isolate aspect-video w-96 rounded-xl bg-background border-[#CD7F32] border-2 shadow-lg ring-1 ring-black/5 px-6 py-2 flex flex-col items-start justify-center">
                            <h1 className="w-fit h-fit text-xl text-semibold text-text">
                                Bachelor of Computer Science
                            </h1>
                            <h3 className="text-text font-bold text-lg">
                                Queensland University of Technology
                            </h3>
                            <p className="text-text font-semibold text-base">
                                2018-2021
                            </p>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}
